var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('target-div',{ref:"tableData1"}),_c('target',{ref:"tableData2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }